<template>
  <div class="flex w-full flex-col gap-4 pb-6 p-4 sm:p-6 bg-neutral_600 rounded-[12px]">
    <div
      class="flex h-[40px] items-center justify-between"
      :class="showDescription ? '' : 'mb-6 sm:mb-10'"
    >
      <p class="font-bold text-[20px] leading-[120%] tracking-[-0.4px] text-base_white">
        {{ $t(`VALUE${index}.name`) }}
      </p>
      <ButtonComponent
        type="outlined"
        :text="`${showDescription ? $t('close') : $t('gradeDescription')}`"
        @click="showDescription = !showDescription"
      />
    </div>
    <div v-if="showDescription" class="pb-6 sm:pb-10">
      <p class="text-neutral_50 text-base font-medium leading-[150%] tracking-[-0.32px]">
        {{ $t(`VALUE${index}.description`) }}
      </p>
    </div>
    <InputRange v-model="internalGrade" :min="1" :max="5" :step="1" />
    <div class="flex items-center justify-between">
      <p
        class="text-[14px] cursor-pointer font-medium text-primary_500 leading-[150%] tracking-[-0.32px]"
        @click="internalGrade = 1"
      >
        {{ $t(`VALUE${index}.worstRating`) }}
      </p>
      <p
        class="text-[14px] cursor-pointer font-medium text-primary_500 leading-[150%] tracking-[-0.32px]"
        @click="internalGrade = 5"
      >
        {{ $t(`VALUE${index}.bestRating`) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';

const props = defineProps({
  index: {
    type: Number,
    required: true
  },
  modelValue: {
    type: Number,
    required: true
  }
});

const emits = defineEmits(['update:modelValue']);

const internalGrade = ref(props.modelValue);
const showDescription = ref(props.index == 1 ? true : false);

watch(internalGrade, (newValue) => {
  emits('update:modelValue', newValue);
});

watch(
  () => props.modelValue,
  (newValue) => {
    internalGrade.value = newValue;
  }
);
</script>
